import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { katanaInput } from '../models/katana-input.service';
import { katanaResult } from '../models/katana-result.service';
import { initId } from '../models/init-id.service';

// import { Observable } from 'rxjs/Observable';
import { Observable } from 'rxjs/Observable'
// import { gecInputSentece } from '../models/gec-input-sentence.service';
import { rejectError } from '../models/reject-suggetions.service';
import { acceptError } from '../models/accept-suggetions.service';
import { environment } from 'src/environments/environment';
import { gecInputSentece } from '../models/gec-input-sentence.service';

@Injectable({
  providedIn: 'root'
})
export class NetworkServicesService {

  constructor(private http:HttpClient) {
    
   }

  postRequestForKatana(data: katanaInput): Observable<katanaResult[]>{
    return this.http.post<katanaResult[]>(environment.server_url.katana_server, data);
  }

  postRequestForGrammerChecker(data: gecInputSentece): Observable<gecInputSentece[]>{
    return this.http.post<gecInputSentece[]>(environment.server_url.gc_server+"/webui/result/", data);
  }

  initApiwhichGetuKey(): Observable<initId>{
    return this.http.get<initId>(environment.server_url.gc_server+"/webui/init/");
  }

  rejectSuggetionsApi(rejectedObj: rejectError): Observable<any>{
    return this.http.post<any[]>(environment.server_url.gc_server+"/webui/store/rejected/", rejectedObj);
  }
  
  acceptSuggetionsApi(rejectedObj: acceptError): Observable<any>{
    return this.http.post<any[]>(environment.server_url.gc_server+"/webui/store/accepted/", rejectedObj);
  }
  getIpAddresss(): Observable<any>{
    return this.http.get<{ ip: string }>('http://gd.geobytes.com/GetCityDetails', {
      headers:
        { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }
    })
  }
  
}
